// @flow strict

import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';

// Components
import ChangeUserRole from 'components/ChangeUserRole';

// Services
import { selectUser } from 'services/Authentication/selectors';
import {
    selectErrors,
    selectQueriedUsers,
    selectTotalCount,
    selectTotalPageCount,
    selectUserIsUpdating,
    selectUsersAreQuerying,
} from 'services/User/selectors';
import { queryV2Users, changeUserRole, unassignUserRole } from 'services/User/thunks';

import { LayoutContainer } from 'styles/common';

// Types
import type { ImmutableUser } from 'services/Authentication/types';
import type { UserSearchCriteria } from 'services/User/types';
import type { ErrorType, ImmutableList, IntlType, ReduxDispatch } from 'types';

const PER_PAGE = 20;

type Props = {
    errors: ErrorType,
    intl: IntlType,
    pageCount: number,
    queriedUsers: ImmutableList<ImmutableUser>,
    queryV2Users: (UserSearchCriteria, ?number, ?number) => void,
    changeUserRole: (number, string) => void,
    unassignUserRole: (number) => void,
    user: ImmutableUser,
    userIsUpdating: boolean,
    usersAreQuerying: boolean,
    usersTotal: number,
};

export class ChangeUserRoleContainer extends React.PureComponent<Props> {
    componentDidMount() {
        this.props.queryV2Users(
            { search: '', sortBy: 'email', sortOrder: 'asc' },
            1,
            PER_PAGE
        );
    }

    handleUsersReFetch = (searchCriteria: UserSearchCriteria, page: number) => {
        this.props.queryV2Users(searchCriteria, page, PER_PAGE);
    };

    render() {
        return (
            <LayoutContainer fullWidth>
                <ChangeUserRole
                    queriedUsers={this.props.queriedUsers}
                    pageCount={this.props.pageCount}
                    usersTotal={this.props.usersTotal}
                    usersAreQuerying={this.props.usersAreQuerying}
                    onUsersReFetch={this.handleUsersReFetch}
                    changeUserRole={this.props.changeUserRole}
                    unassignUserRole={this.props.unassignUserRole}
                    userIsUpdating={this.props.userIsUpdating}
                />
            </LayoutContainer>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    errors: selectErrors(),
    pageCount: selectTotalPageCount(),
    queriedUsers: selectQueriedUsers(),
    user: selectUser(),
    userIsUpdating: selectUserIsUpdating(),
    usersAreQuerying: selectUsersAreQuerying(),
    usersTotal: selectTotalCount(),
});

const mapDispatchToProps = (dispatch: ReduxDispatch) =>
    bindActionCreators(
        {
            queryV2Users,
            changeUserRole,
            unassignUserRole,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ChangeUserRoleContainer));
